module.exports = {
      id: "ic-euro-50-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-euro-50-usage",
      toString: function () {
        return this.url;
      }
    }